/* eslint-disable no-unused-vars */
import Vue from "vue";
import axios from "axios";
import moment from "moment";
import { getField, updateField } from "vuex-map-fields";

let state = {
  loading: true,
  product: null,
  variantId: null
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setProduct(state, product) {
    state.product = product;
  },
  updateVariantField(state, field) {
    updateField(state, field);

    let uri = window.location.href.split("?");
    var url = window.location.href;
    if (uri.length == 2) {
      url = uri[0];
    }
    var queryParams = new URLSearchParams(window.location.search);

    let replaceUrl = state.variantId
      ? `/smart-vault/${state.product.id}/${state.variantId}`
      : `/smart-vault/${state.product.id}`;
    history.replaceState(null, "", replaceUrl + "?" + queryParams.toString());
  },
  setVariant(state, id) {
    state.variantId = id;
  }
};

const actions = {
  getProduct({ state, commit }, id) {
    return new Promise((resolve, reject) => {
      commit("setLoading", true);
      axios
        .get(`/api/products/${id}`)
        .then(resp => {
          resp.data.data.variants.forEach(function(variant) {
            if (variant.hidden == "true") {
              resp.data.data.variants.splice(
                resp.data.data.variants.indexOf(variant),
                1
              );
            }
          });
          commit("setProduct", resp.data.data);
          resolve(resp.data.data);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("setLoading", false);
        });
    });
  }
};

const getters = {
  getField,
  getVariant: state => {
    return state.variantId
      ? state.product.variants.find(v => v.id === state.variantId)
      : null;
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
